var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import Popconfirm from 'antd/lib/popconfirm';
import 'antd/lib/button/style/index.css';
import 'antd/lib/popover/style/index.css';
import Switch from 'antd/lib/switch';
import 'antd/lib/switch/style/index.css';
var SwitchRoundFlag = (function (_super) {
    __extends(SwitchRoundFlag, _super);
    function SwitchRoundFlag(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: !!props.round[props.field],
            isFetching: false,
        };
        _this.handlePatchRound = _this.handlePatchRound.bind(_this);
        return _this;
    }
    SwitchRoundFlag.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ value: !!nextProps.round[nextProps.field] });
    };
    SwitchRoundFlag.prototype.handlePatchRound = function () {
        var _this = this;
        var field = this.props.field;
        var nextRound = (_a = {
                id: this.props.round.id,
                eventId: this.props.round.eventId
            },
            _a[field] = !this.state.value,
            _a);
        this.setState({ isFetching: true });
        this.props.handlePatchRound(nextRound)
            .then(function (res) {
            _this.setState({
                value: !!res.value[field],
                isFetching: false,
            });
        })
            .catch(function (err) {
            message.error(err.message);
            _this.setState({ isFetching: false });
        });
        var _a;
    };
    SwitchRoundFlag.prototype.render = function () {
        return (React.createElement(Popconfirm, { title: this.state.value ? this.props.confirmMessageSetFalse : this.props.confirmMessageSetTrue, onConfirm: this.handlePatchRound },
            React.createElement("div", null,
                React.createElement(Switch, { checked: this.state.value, loading: this.state.isFetching }))));
    };
    return SwitchRoundFlag;
}(React.Component));
export default SwitchRoundFlag;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListRoundPage/SwitchRoundFlag.tsx
// module id = 236
// module chunks = 0